<div class="container-fluid">
    <h1>{{data.details.title}}</h1>
</div>